import * as React from 'react'
import { compose, pure } from 'recompose'

import LinkButton from '../../atoms/LinkButton/LinkButton'
import * as styles from './ProjectInfo.css'

interface ProjectInfoProps {
  title: string
  isStarted: boolean
}

const ProjectInfo: React.FunctionComponent<ProjectInfoProps> = ({ title, isStarted }) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <h1 className={styles.titleText}>{title}</h1>
    </div>
    {isStarted ? null : (
      <div className={styles.notice}>
        <p className={styles.noticeText}>この先のコンテンツは当日利用します。</p>
      </div>
    )}
    <div className={styles.button}>
      <LinkButton to={`/signup${window.location.search}`} isEnabled={isStarted}>
        {isStarted ? '参加する' : '開始までお待ち下さい'}
      </LinkButton>
    </div>
  </div>
)

export default compose<ProjectInfoProps, ProjectInfoProps>(pure)(ProjectInfo)
